import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "rounded-md bg-red-100 p-4 mt-4"
}
const _hoisted_2 = { class: "flex" }
const _hoisted_3 = { class: "flex-shrink-0" }
const _hoisted_4 = { class: "ml-3 flex-1 md:flex md:justify-between items-center" }
const _hoisted_5 = { class: "alert-text" }
const _hoisted_6 = { class: "text-md text-red-800 font-semibold" }
const _hoisted_7 = { class: "text-sm text-red-800" }
const _hoisted_8 = {
  key: 0,
  class: "mt-3 text-sm md:ml-6 md:mt-0"
}

import { Rollover } from "@/interfaces/rollover.interface";
import { computed } from "vue";
import { useRouter } from "vue-router";
import { useFilterStore } from "@/stores/filterStore";
import i18n from "@/plugins/i18n";
import { useRolloverStore } from "@/stores/rolloverStore";


export default /*#__PURE__*/_defineComponent({
  __name: 'RolloverAlertComponent',
  props: {
    rollover: {}
  },
  emits: ["confirmRolloverDateModal", "completeRolloverModal"],
  setup(__props: any, { emit }) {

const props = __props;

const router = useRouter();
const filterStore = useFilterStore();
const rolloverStore = useRolloverStore();





const assignStudentsToClass = async () => {
  const rollover = rolloverStore.rollover;
  if (rollover) await rolloverStore.runAssignLearnersJob(rollover._id);
};

const rolloverAlert = computed(() => {
  const { learnerRollover, classReview, learnerAssignment } =
    props.rollover.status;
  const isComplete = props.rollover.isComplete;

  let alertButtonText = "";
  let alertButtonAction = () => {
    return;
  };

  if (
    learnerRollover === "to_do" &&
    classReview === "to_do" &&
    learnerAssignment === "to_do" &&
    !isComplete
  ) {
    alertButtonText =  i18n.global.t("internal_tools.rollover_alert_compoent.btn_start").toString();
    alertButtonAction = () => {
      emit("confirmRolloverDateModal", true);
    };
    return {
      alertButtonText,
      showButton: true,
      alertButtonAction,
      title: i18n.global.t("internal_tools.rollover_alert_compoent.grade_title", { grade : filterStore.selectedFilters.gradeLevel } ).toString(),
      subtitle: i18n.global.t("internal_tools.rollover_alert_compoent.grade_sub_title").toString(),
    };
  } else if (learnerRollover === "in_review") {
    alertButtonText = i18n.global.t("internal_tools.rollover_alert_compoent.btnContinue").toString();
    alertButtonAction = () => router.push("/main/incomplete-rollover");
    return {
      alertButtonText,
      showButton: true,
      alertButtonAction,
      title:  i18n.global.t("internal_tools.rollover_alert_compoent.learner_text").toString(),
      subtitle: i18n.global.t("internal_tools.rollover_alert_compoent.please_review").toString(),
    };
  } else if (learnerRollover === "pending_job_run" && classReview === "to_do") {
    alertButtonText = i18n.global.t("internal_tools.rollover_alert_compoent.btn_start_class").toString();
    alertButtonAction = () => router.push("/main/review-class-structure");
    return {
      alertButtonText,
      showButton: true,
      alertButtonAction,
      title: i18n.global.t("internal_tools.rollover_alert_compoent.class_review").toString(),
      subtitle: i18n.global.t("internal_tools.rollover_alert_compoent.learner_rollover_confirm").toString(),
    };
  } else if (
    learnerRollover === "pending_job_run" &&
    classReview === "in_review"
  ) {
    alertButtonText = i18n.global.t("internal_tools.rollover_alert_compoent.continue_class_review").toString();
    alertButtonAction = () => router.push("/main/review-class-structure");
    return {
      alertButtonText,
      showButton: true,
      alertButtonAction,
      title: i18n.global.t("internal_tools.rollover_alert_compoent.class_review_in").toString(),
      subtitle: i18n.global.t("internal_tools.rollover_alert_compoent.class_review_details").toString(),
    };
  } else if (
    learnerRollover === "pending_job_run" &&
    classReview === "pending_job_run"
  ) {
    alertButtonText = i18n.global.t("internal_tools.rollover_alert_compoent.start_class_review").toString();
    alertButtonAction = () => {
      return;
    };
    return {
      alertButtonText,
      showButton: false,
      alertButtonAction,
      title: i18n.global.t("internal_tools.rollover_alert_compoent.rollover_to_be", {
        date: new Date(props.rollover.rolloverDate).toISOString().split("T")[0]
      }),
      subtitle: i18n.global.t("internal_tools.rollover_alert_compoent.all_details").toString(),
    };
  } else if (
    learnerRollover === "complete" &&
    classReview === "complete" &&
    learnerAssignment === "to_do" && !rolloverStore.allLearnersAssigned
  ) {
    alertButtonText = i18n.global.t("internal_tools.rollover_alert_compoent.assign_learners").toString();
    alertButtonAction = () => router.push("/main/add-student");
    return {
      alertButtonText,
      showButton: true,
      alertButtonAction,
      title: i18n.global.t("internal_tools.rollover_alert_compoent.learners_to_class").toString(),
      subtitle: i18n.global.t("internal_tools.rollover_alert_compoent.rollover_class_review").toString(),
    };
  } else if (
    learnerRollover === "complete" &&
    classReview === "complete" &&
    learnerAssignment === "to_do" && rolloverStore.allLearnersAssigned
  ) {
    alertButtonText = i18n.global.t("internal_tools.rollover_alert_compoent.learner_assignment_pending_button").toString();
    alertButtonAction = () => assignStudentsToClass();
    return {
      alertButtonText,
      showButton: true,
      alertButtonAction,
      title: i18n.global.t("internal_tools.rollover_alert_compoent.learner_assignment_pending_title").toString(),
      subtitle: i18n.global.t("internal_tools.rollover_alert_compoent.learner_assignment_pending_subtitle").toString(),
    };
  } else if (
    learnerRollover === "complete" &&
    classReview === "complete" &&
    learnerAssignment === "in_review"
  ) {
    alertButtonText = i18n.global.t("internal_tools.rollover_alert_compoent.finish_assign").toString();
    alertButtonAction = () => router.push("/main/add-student");
    return {
      alertButtonText,
      showButton: true,
      alertButtonAction,
      title: i18n.global.t("internal_tools.rollover_alert_compoent.learners_assign_in_progress").toString(),
      subtitle: i18n.global.t("internal_tools.rollover_alert_compoent.learners_assigning").toString(),
    };
  } else if (
    learnerRollover === "complete" &&
    classReview === "complete" &&
    learnerAssignment === "complete" &&
    !isComplete
  ) {
    alertButtonText = i18n.global.t("internal_tools.rollover_alert_compoent.rollover_complet").toString();
    alertButtonAction = () => {
      emit("completeRolloverModal", true);
    };
    return {
      alertButtonText,
      showButton: true,
      alertButtonAction,
      title: i18n.global.t("internal_tools.rollover_alert_compoent.rollover_complet").toString(),
      subtitle: i18n.global.t("internal_tools.rollover_alert_compoent.all_steps").toString(),
    };
  } else {
    alertButtonText = i18n.global.t("internal_tools.rollover_alert_compoent.error_unknown_state").toString();
    alertButtonAction = () => {
      return;
    };
    return {
      alertButtonText,
      showButton: true,
      alertButtonAction,
      title: '',
      subtitle: '',
    };
  }
});


return (_ctx: any,_cache: any) => {
  const _component_rl_icon = _resolveComponent("rl-icon")!

  return (rolloverAlert.value.title)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_rl_icon, {
              icon: 'rl-pink-alert',
              title: 'rl pnik alert',
              "aria-hidden": "true"
            })
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("p", _hoisted_6, _toDisplayString(rolloverAlert.value.title), 1),
              _createElementVNode("p", _hoisted_7, _toDisplayString(rolloverAlert.value.subtitle), 1)
            ]),
            (rolloverAlert.value.showButton)
              ? (_openBlock(), _createElementBlock("p", _hoisted_8, [
                  _createElementVNode("button", {
                    class: "whitespace-nowrap font-medium text-red-700 hover:text-red-600 border-solid border border-red-800 rounded-full py-2 px-6",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (rolloverAlert.value.alertButtonAction()))
                  }, [
                    _createElementVNode("span", null, _toDisplayString(rolloverAlert.value.alertButtonText), 1)
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})